import { useCallback } from 'react';

import { ApiErrors, isApiError } from '@common/api-request';

import { removeUmdSavedProduct, saveWebUmdProduct } from '../graphql/product-umd.2';
import type { UmdProductIdentifiersInput } from '../graphql/product-umd_types.2';
import { likeStatusStore } from '../store/LikeStore';

export const useMutateWebLikeProduct = () => {
  const handleSaveMutate = useCallback(async (productData: UmdProductIdentifiersInput) => {
    const catalog_product_id = productData.catalog_product_id ?? '';
    likeStatusStore.setState({ [catalog_product_id]: true });
    try {
      const result = await saveWebUmdProduct(
        { product_ids: productData },
        { ignore_error: ApiErrors.NOT_LOGGED_IN, show_alert: false },
      );
      const error = result.errors?.[0];
      if (isApiError(error) && error.message === ApiErrors.NOT_LOGGED_IN) {
        throw error;
      }
    } catch (error) {
      likeStatusStore.setState({ [catalog_product_id]: false });
      throw error;
    }
  }, []);

  const handleRemoveMutate = useCallback(async (productData: UmdProductIdentifiersInput) => {
    const catalog_product_id = productData.catalog_product_id ?? '';
    likeStatusStore.setState({ [catalog_product_id]: false });
    try {
      const result = await removeUmdSavedProduct(
        { product_info: { product_ids_list: [productData] } },
        { ignore_error: ApiErrors.NOT_LOGGED_IN, show_alert: false },
      );
      if (!result.data.removeUmdSavedProduct) {
        likeStatusStore.setState({ [catalog_product_id]: true });
      }
      const error = result.errors?.[0];
      if (isApiError(error) && error.message === ApiErrors.NOT_LOGGED_IN) {
        throw error;
      }
    } catch (error) {
      likeStatusStore.setState({ [catalog_product_id]: true });
      throw error;
    }
  }, []);

  return { saveMutate: handleSaveMutate, removeMutate: handleRemoveMutate };
};
